(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kintergravit-landing"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* === FAQ Accordion === */
  var faqItems = document.querySelectorAll('[data-kg-faq]');
  faqItems.forEach(function(item) {
    var btn = item.querySelector('.kg-faq__q');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var isOpen = item.getAttribute('data-open') === 'true';
      /* Close all */
      faqItems.forEach(function(other) {
        other.removeAttribute('data-open');
      });
      /* Toggle current */
      if (!isOpen) {
        item.setAttribute('data-open', 'true');
      }
    });
  });

  /* === Sport Protocol Tabs === */
  var tabs = document.querySelectorAll('[data-kg-sport-tab]');
  var panels = document.querySelectorAll('[data-kg-sport-panel]');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var target = tab.getAttribute('data-kg-sport-tab');
      /* Deactivate all */
      tabs.forEach(function(t) { t.classList.remove('kg-sport__tab--active'); });
      panels.forEach(function(p) { p.style.display = 'none'; p.classList.remove('kg-sport__panel--active'); });
      /* Activate current */
      tab.classList.add('kg-sport__tab--active');
      var panel = document.querySelector('[data-kg-sport-panel="' + target + '"]');
      if (panel) {
        panel.style.display = 'block';
        panel.classList.add('kg-sport__panel--active');
      }
    });
  });

  /* === Mobile Menu Toggle === */
  var toggleBtn = document.querySelector('[data-kg-mobile-toggle]');
  var mobileMenu = document.getElementById('kg-mobile-menu');
  if (toggleBtn && mobileMenu) {
    var openIcon = toggleBtn.querySelector('.kg-mobile-toggle__open');
    var closeIcon = toggleBtn.querySelector('.kg-mobile-toggle__close');
    toggleBtn.addEventListener('click', function() {
      var isHidden = mobileMenu.style.display === 'none';
      mobileMenu.style.display = isHidden ? 'flex' : 'none';
      if (openIcon) openIcon.style.display = isHidden ? 'none' : 'block';
      if (closeIcon) closeIcon.style.display = isHidden ? 'block' : 'none';
    });
    /* Close menu on link click */
    var menuLinks = mobileMenu.querySelectorAll('a');
    menuLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        mobileMenu.style.display = 'none';
        if (openIcon) openIcon.style.display = 'block';
        if (closeIcon) closeIcon.style.display = 'none';
      });
    });
  }

  /* === Add-to-Cart (AJAX, stays on landing) === */
  var toast = document.getElementById('kg-toast');
  var toastProduct = document.getElementById('kg-toast-product');
  var toastHideTimer = null;

  function showToast(productName, isError) {
    if (!toast) return;
    toast.classList.remove('is-error');
    if (isError) toast.classList.add('is-error');
    var titleEl = toast.querySelector('.kg-toast__title');
    if (titleEl) titleEl.textContent = isError ? 'Errore' : 'Aggiunto al carrello';
    if (toastProduct) toastProduct.textContent = productName || '';
    toast.classList.add('is-visible');
    toast.setAttribute('aria-hidden', 'false');
    if (toastHideTimer) clearTimeout(toastHideTimer);
    toastHideTimer = setTimeout(function() {
      toast.classList.remove('is-visible');
      toast.setAttribute('aria-hidden', 'true');
    }, 4200);
  }

  var cartBar = document.getElementById('kg-cart-bar');
  var cartBarCount = document.querySelector('[data-cart-bar-count]');
  var cartBarLabel = document.querySelector('[data-cart-bar-label]');
  var cartBarTotal = document.querySelector('[data-cart-bar-total]');

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: 2
      }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  function updateCartCount() {
    /* Fire-and-forget cart count refresh; theme-agnostic. */
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.dispatchEvent(new CustomEvent('kg:cart:updated', { detail: cart }));
        var countNodes = document.querySelectorAll('[data-cart-count], .cart-count, .cart-link__bubble-num');
        countNodes.forEach(function(n) {
          n.textContent = cart.item_count;
          if (cart.item_count > 0) n.classList.remove('is-hidden');
          else n.classList.add('is-hidden');
        });
        /* Bump animation on cart icon */
        var cartIcons = document.querySelectorAll('[data-kg-cart-link]');
        cartIcons.forEach(function(c) {
          c.classList.remove('is-bumping');
          void c.offsetWidth;
          c.classList.add('is-bumping');
        });
        /* Sticky checkout bar: visibility + content */
        if (cartBar) {
          if (cart.item_count > 0) {
            cartBar.classList.add('is-visible');
            cartBar.setAttribute('aria-hidden', 'false');
          } else {
            cartBar.classList.remove('is-visible');
            cartBar.setAttribute('aria-hidden', 'true');
          }
        }
        if (cartBarCount) cartBarCount.textContent = cart.item_count;
        if (cartBarLabel) cartBarLabel.textContent = cart.item_count === 1 ? 'prodotto' : 'prodotti';
        if (cartBarTotal) cartBarTotal.textContent = formatMoney(cart.total_price, cart.currency);
      })
      .catch(function() {});
  }

  /* Sync bar state on page load (covers session-restored carts) */
  updateCartCount();

  var atcButtons = document.querySelectorAll('[data-kg-atc]');
  atcButtons.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      var variantIdsAttr = btn.getAttribute('data-variant-ids') || '';
      var productName = btn.getAttribute('data-product-name') || '';
      var labelEl = btn.querySelector('.kg-atc__label');
      var originalLabel = labelEl ? labelEl.textContent : '';

      /* Costruisci la lista degli articoli da aggiungere.
         Priorita': prodotto-bundle singolo (data-variant-id); altrimenti piu' varianti (data-variant-ids). */
      /* Normalizza un ID variante: rimuove spazi, estrae il numero da un eventuale GID
         (gid://shopify/ProductVariant/123) e scarta tutto cio' che non e' cifra. */
      function kgNormId(raw) {
        if (!raw) return '';
        var s = String(raw).trim();
        if (s.indexOf('/') !== -1) { s = s.split('/').pop(); }
        return s.replace(/[^0-9]/g, '');
      }

      var items = [];
      var single = kgNormId(variantId);
      if (single) {
        items = [{ id: single, quantity: 1 }];
      } else if (variantIdsAttr) {
        variantIdsAttr.split(',').forEach(function(raw) {
          var id = kgNormId(raw);
          if (id) items.push({ id: id, quantity: 1 });
        });
      }

      if (items.length === 0) {
        showToast('Collega i prodotti nelle impostazioni della sezione', true);
        btn.classList.add('is-error');
        if (labelEl) labelEl.textContent = 'Prodotto non collegato';
        setTimeout(function() {
          btn.classList.remove('is-error');
          if (labelEl) labelEl.textContent = originalLabel;
        }, 2400);
        return;
      }

      btn.classList.add('is-loading');
      if (labelEl) labelEl.textContent = 'Aggiungo...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function(r) {
          if (!r.ok) return r.json().then(function(err) { throw err; });
          return r.json();
        })
        .then(function() {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          if (labelEl) labelEl.textContent = 'Aggiunto!';
          showToast(productName);
          updateCartCount();
          setTimeout(function() {
            btn.classList.remove('is-added');
            if (labelEl) labelEl.textContent = originalLabel;
          }, 2400);
        })
        .catch(function(err) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          if (labelEl) labelEl.textContent = 'Riprova';
          var msg = (err && (err.description || err.message)) || 'Non sono riuscito ad aggiungere ' + productName;
          showToast(msg, true);
          setTimeout(function() {
            btn.classList.remove('is-error');
            if (labelEl) labelEl.textContent = originalLabel;
          }, 2400);
        });
    });
  });

  /* === Schede Prodotto — Modali === */
  var schedaTriggers = document.querySelectorAll('[data-kg-scheda]');
  var lastSchedaTrigger = null;

  function openScheda(key) {
    var modal = document.getElementById('kg-scheda-' + key);
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('kg-modal-open');
    requestAnimationFrame(function() { modal.classList.add('is-open'); });
    var closeBtn = modal.querySelector('.kg-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeScheda(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('kg-modal-open');
    setTimeout(function() { modal.hidden = true; }, 240);
    if (lastSchedaTrigger) { lastSchedaTrigger.focus(); lastSchedaTrigger = null; }
  }

  schedaTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      lastSchedaTrigger = trigger;
      openScheda(trigger.getAttribute('data-kg-scheda'));
    });
  });

  document.querySelectorAll('[data-kg-modal-close]').forEach(function(el) {
    el.addEventListener('click', function() {
      closeScheda(el.closest('[data-kg-modal]'));
    });
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var openModal = document.querySelector('[data-kg-modal].is-open');
      if (openModal) closeScheda(openModal);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
